// Piezas compartidas por las dos pantallas de permisos de marcado:
// `PermisosCliente` (residencial: plantilla del cliente + una sección por línea) y
// `PermisosTroncal` (corporativo: troncal → DID → permisos).
//
// Vivían duplicadas en cada componente. La matriz de categorías es la misma en los tres
// niveles (cliente, línea, DID) y conviene que lo siga siendo: es lo que el AGI evalúa.

// Fetch pelado para que un 401 no dispare la redirección a /login del interceptor de axios
// (acá un 403 es información —el rol no llega a ese dato—, no motivo para desloguear).
export async function permFetch(path, method = "GET", body = null) {
  const token = localStorage.getItem("token");
  const opts = {
    method,
    headers: { Authorization: `Bearer ${token || ""}`, "Content-Type": "application/json" },
  };
  if (body !== null) opts.body = JSON.stringify(body);
  const res = await fetch(`/v1${path}`, opts);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || `HTTP ${res.status}`);
  }
  return res.status === 204 ? null : res.json();
}

export const safe = async (fn) => { try { return await fn(); } catch { return null; } };

export const mono = { fontFamily: "var(--font-mono)", fontVariantNumeric: "tabular-nums" };

/* ── Matriz de categorías — sirve para un DID, una línea o todo el cliente ── */
export function Matriz({ cats, valores, onChange, editable }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {cats.map(cat => {
        const val = valores[cat.nombre] ?? !!cat.permitido_default;
        return (
          <div key={cat.nombre} style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "8px 12px", borderRadius: "var(--r-sm)",
            background: val ? "var(--success-bg,rgba(34,197,94,.06))" : "var(--danger-bg,rgba(239,68,68,.06))",
            border: `1px solid ${val ? "rgba(0,201,141,.2)" : "rgba(239,68,68,.2)"}`,
          }}>
            <div>
              <div style={{ fontSize: 12.5, fontWeight: 600, color: "var(--text-primary)" }}>{cat.label}</div>
              <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>
                Prefijos: {(cat.prefijos || []).join(", ") || "—"}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 11, fontWeight: 600,
                color: val ? "var(--success,#22c55e)" : "var(--danger,#ef4444)" }}>
                {val ? "Permitido" : "Bloqueado"}
              </span>
              <input type="checkbox" checked={val} disabled={!editable}
                onChange={e => onChange(cat.nombre, e.target.checked)}
                style={{ width: 16, height: 16, cursor: editable ? "pointer" : "not-allowed" }}/>
            </div>
          </div>
        );
      })}
    </div>
  );
}
